import React from "react";
import { useI18n } from "@/lib/i18n";

/* Composant UNIQUE d'adresse Hub — même structure partout :
   Adresse · Ville · Code postal · Pays · Téléphone · Horaires.
   Toutes les données viennent du Hub central (Admin > Hubs). */
export const HubAddress = ({ hub, recipient, className = "" }) => {
  const { t } = useI18n();
  if (!hub) return null;
  const rows = [
    ["hub.addr", hub.address],
    ["hub.city", hub.city],
    ["hub.postal", hub.postal_code],
    ["hub.country", hub.country],
    ["hub.phone", hub.phone],
    ["hub.hours", hub.hours],
  ].filter(([, v]) => v);
  return (
    <div className={`text-sm ${className}`} data-testid="hub-address">
      {recipient && <div className="font-heading font-bold" data-testid="hub-address-recipient">{recipient}</div>}
      <dl className="mt-1 space-y-0.5">
        {rows.map(([k, v]) => (
          <div key={k} className="flex gap-2">
            <dt className="w-28 shrink-0 text-muted-foreground">{t(k)}</dt>
            <dd className="font-medium" data-testid={`hub-address-${k.split(".")[1]}`}>{v}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
};

/* Texte copiable — même structure que l'affichage */
export const hubAddressText = (hub, t, recipient) =>
  [recipient,
   `${t("hub.addr")} : ${hub.address}`,
   `${t("hub.city")} : ${hub.city}`,
   hub.postal_code ? `${t("hub.postal")} : ${hub.postal_code}` : "",
   `${t("hub.country")} : ${hub.country}`,
   hub.phone ? `${t("hub.phone")} : ${hub.phone}` : "",
   hub.hours ? `${t("hub.hours")} : ${hub.hours}` : ""].filter(Boolean).join("\n");
